import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { PrivacyLink } from "@/components/PrivacyModal";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!window.localStorage.getItem("cliniativa-cookies")) {
      const t = setTimeout(() => setVisible(true), 2500);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    window.localStorage.setItem("cliniativa-cookies", value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 48, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 48, scale: 0.96 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-4 bottom-4 z-[70] sm:inset-x-auto sm:bottom-6 sm:left-6 sm:max-w-md"
        >
          <div className="glass-paper rounded-3xl p-6 shadow-[0_24px_60px_rgba(16,42,67,0.28)]">
            <div className="flex items-start gap-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-[var(--brand)]/12 text-[var(--brand)]">
                <Cookie className="h-5 w-5" />
              </span>
              <div>
                <p className="font-display text-sm font-bold text-[var(--ink)]">Cookies e privacidade</p>
                <p className="mt-1.5 text-xs leading-relaxed text-[var(--muted)]">
                  Usamos cookies para melhorar sua experiência e entender como o site é usado. Você pode
                  aceitar ou recusar — os detalhes estão na nossa <PrivacyLink />.
                </p>
              </div>
            </div>
            <div className="mt-5 flex gap-3">
              <button
                data-testid="cookie-accept-button"
                onClick={() => choose("accepted")}
                className="flex-1 rounded-full bg-petrol py-2.5 text-sm font-semibold text-white transition-[transform,background-color] duration-300 hover:scale-[1.02] dark:bg-turquoise dark:text-petrol"
              >
                Aceitar
              </button>
              <button
                data-testid="cookie-decline-button"
                onClick={() => choose("declined")}
                className="flex-1 rounded-full border border-[var(--line)] py-2.5 text-sm font-semibold text-[var(--ink)] transition-colors duration-300 hover:border-[var(--brand)] hover:text-[var(--brand)]"
              >
                Recusar
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
